// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___38QSn","addText":"AddFilterBox__addText___8KhVf","addFilterContainer":"AddFilterBox__addFilterContainer___o0qco","addIcon":"AddFilterBox__addIcon___1flU_"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/users/components/AddFilterBox.scss
// module id = 1661
// module chunks = 0